module.exports = __webpack_public_path__ + "static/Purchasing Power Stablecoin-1b695338fe4a6cc41bad9a3c6aeafa3e.pdf";